export default {
  documents: [],
  document: null,
  pagination: {
    currentPage: 1,
    totalPage: 1,
    pageTotal: 0,
    totalItem: 0,
  },
  stats: {},
  syncStatus: {},
}

